import { configureStore } from '@reduxjs/toolkit';

import authReducer from './slices/authSlice';
import charactersReducer from './slices/charactersSlice';
import itemsReducer from './slices/itemsSlice';
import alertsReducer from './slices/alertsSlice';
import dashboardReducer from './slices/dashboardSlice';
import notificationReducer from './slices/notificationSlice';
import filterReducer from './slices/filterSlice';
import tasksReducer from './slices/tasksSlice';
import marketAnalysisReducer from './slices/marketAnalysisSlice';
import flipsReducer from './slices/flipsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    characters: charactersReducer,
    items: itemsReducer,
    alerts: alertsReducer,
    dashboard: dashboardReducer,
    notification: notificationReducer,
    filter: filterReducer,
    tasks: tasksReducer,
    marketAnalysis: marketAnalysisReducer,
    flips: flipsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
